"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addDeviceEventObserverToSession = addDeviceEventObserverToSession;
var _logger = require("@studio/logger");
var _constants = require("@studio/constants");
function addDeviceEventObserverToSession(dispatch, showModal, meetingSession) {
  if (!meetingSession.deviceController.eventController) {
    console.info('Cannot add eventController observer to deviceController as no eventController has been created.');
    return;
  }
  meetingSession.deviceController.eventController.addObserver({
    eventDidReceive: function eventDidReceive(eventName) {
      var meetingId = meetingSession.configuration.meetingId;
      var logPayload = {
        'studio.meeting.id': meetingId,
        title: "Chime session eventController raised event: ".concat(eventName)
      };
      (0, _logger.sendToDatadog)('chime-sdk-events', logPayload, logPayload.title, false);
      if (['audioInputFailed'].includes(eventName)) {
        dispatch(showModal(_constants.AUDIO_INPUT_FAILED));
      }
    }
  });
}